module.exports = __webpack_public_path__ + "img/twitch.656deef9.svg";